module.exports = __webpack_public_path__ + "img/Kubernetes-Services-logo.a061725e.webp";